import { UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useLocation } from 'react-router';
import { useGetRecordDraft } from '../api';
import { useDashboardChartFormProcess } from '../hooks/useDashboardChartFormProcess';
import { DraftExerciseRecordDto } from '../types';

/**
 * 운동차트 수정 페이지에서 사용
 *
 * 임시저장된 운동차트 정보를 가져옴
 */
export const useDraftChartForEdit = (
  options?: UseQueryOptions<
    DraftExerciseRecordDto,
    AxiosError,
    DraftExerciseRecordDto,
    string[]
  >
) => {
  const { searchQuery } = useDashboardChartFormProcess();
  const { registeredLectureId } = searchQuery;

  const { pathname } = useLocation();
  const isEditPage = pathname.includes('/chart/form/edit');

  const { data: draftChart } = useGetRecordDraft(
    registeredLectureId as string,
    {
      enabled: !!registeredLectureId && isEditPage,
      ...options
    }
  );

  return { draftChart };
};
